import styled from "styled-components";

export const LandingContainer = styled.div`
  z-index: 1;
  width: 100%;
  height: 800px;
  background-color: #202023;
  max-width: 100%;
  margin-right: auto;
  margin-left: auto;

  border-radius: 0% 0% 0% 100% / 100px;

  @media screen and (max-width: 991px) {
    padding-right: 30px;
    padding-left: 30px;
  }

  /* I didn't use below codes in the end, it makes landing div background look cool */

  /* background: linear-gradient(-45deg, #da1e37, #202023, #da1e37, #da1e37);
  background-size: 400% 400%;
  animation: gradient 10s ease infinite; */
  /* border-bottom-left-radius: 10%;
  border-bottom-right-radius: 20%; */
`;

export const Container = styled.div`
  z-index: 1;
  width: 100%;
  max-width: 1300px;
  margin-right: auto;
  margin-left: auto;
  padding-right: 50px;
  padding-left: 50px;

  @media screen and (max-width: 991px) {
    padding-right: 30px;
    padding-left: 30px;
  }
`;

export const InfoSec = styled.div`
  color: #fff;
  padding: 160px 0;
`;

export const InfoRow = styled.div`
  display: flex;
  margin: 0 -15px -15px -15px;
  flex-wrap: wrap;
  align-items: center;
  flex-direction: ${({ imgStart }) => (imgStart ? "row-reverse" : "row")};
`;

export const InfoColumn = styled.div`
  margin-bottom: 15px;
  padding-right: 15px;
  padding-left: 15px;
  flex: 1;
  max-width: 50%;
  flex-basis: 50%;

  @media screen and (max-width: 768px) {
    max-width: 100%;
    flex-basis: 100%;
    display: flex;
    justify-content: center;
  }
`;

export const TextWrapper = styled.div`
  max-width: 540px;
  padding-top: 0;
  padding-bottom: 60px;

  @media screen and (max-width: 768px) {
    padding-bottom: 65px;
  }
`;

export const Heading = styled.h1`
  margin-bottom: 24px;
  font-size: 25px;
  line-height: 1.1;
  font-weight: 1000;
  line-height: 1.5;
  text-align: center;

  color: #e8e9eb;
  @media screen and (max-width: 991px) {
    font-size: 18px;
  }
`;

export const Subtitle = styled.p`
  margin-bottom: 35px;
  font-size: 18px;
  line-height: 30px;
  color: #ced4da;
  text-align: center;

  @media screen and (max-width: 991px) {
    line-height: 24px;
    font-size: 16px;

    text-align: justify;
    text-justify: inter-word;
  }
`;

export const ImgWrapper = styled.div`
  max-width: 555px;
  display: flex;
  justify-content: ${({ start }) => (start ? "flex-start" : "flex-end")};
`;

export const Img = styled.img`
  padding-right: 0;
  border: 0;
  max-width: 100%;
  vertical-align: middle;
  display: inline-block;
  max-height: 500px;
`;
